import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { followApi, unFollowApi } from "../../API/API";

function* followSaga(params) {
    
    try {
        // const {id} = action.payload;
        const response = yield call(() => followApi(params));
        yield put({type: types.POST_FOLLOW_SUCCESS, payload: response.data});
    } catch (error) {
        yield put({type: types.POST_FOLLOW_FAILURE, error});
    }
}

export function* watchFollowSaga() {
    yield takeEvery(types.POST_FOLLOW_REQUESTED, followSaga);
}

function* unFollowSaga(params) {
    
    try {
        // const {limit, skip, status,search} = action.payload;
        const response = yield call(() => unFollowApi(params));
        yield put({type: types.POST_UNFOLLOW_SUCCESS, payload: response.data});
    } catch (error) {
        yield put({type: types.POST_UNFOLLOW_FAILURE, error});
    }
}

export function* watchUnFollowSaga() {
    yield takeEvery(types.POST_UNFOLLOW_REQUESTED, unFollowSaga);
}